// 1. 企业微信浏览器、
// 2. 微信浏览器
// 3. 普通浏览器
import { useUserStore } from "@/stores/modules/user";

/** 浏览器类型 */
export enum BROWSER_TYPE {
    /** 企业微信浏览器 */
    WX_WORK = 1
}

export const getBrowserEnv = (): number => {
    const UA: string = navigator.userAgent.toLowerCase();
    if (UA.indexOf("micromessenger") !== -1) {
        return UA.indexOf("wxwork") !== -1 ? 1 : 2;
    }
    return 3;
};

export const hasPermissions = (permission: string) => {
    const userStore = useUserStore();
    const permissions = userStore.userInfo.permissions;
    return permissions.includes(permission);
};
